module.exports = __webpack_public_path__ + "img/three-tu@3x.493e13da.png";